import ImagePerson from "@/components/functionals/ImagePerson.vue";
import HyperlinkForAutoMvReport from "@/components/functionals/HyperlinkForAutoMvReport.vue";

export const AutoMVcolumns = [
  {
    prop: "UserId",
    label: "ID",
    minWidth: 80,
    fixed: true,
    sortable: true
  },
  {
    prop: "EmployeeName",
    label: "Nombre del Empleado",
    minWidth: 200,
    fixed: true,
    formatter: ImagePerson,
    attrs: {
      imgKey: "ImagePerson"
    },
    sortable: true
  },
  {
    prop: "Enero",
    label: "Enero",
    minWidth: 120,
    //fixed: true,
    sortable: true,
    formatter: HyperlinkForAutoMvReport
  },
  {
    prop: "Febrero",
    label: "Febrero",
    minWidth: 120,
    //fixed: true,
    sortable: true,
    formatter: HyperlinkForAutoMvReport
  },
  {
    prop: "Marzo",
    label: "Marzo",
    minWidth: 120,
    //fixed: true,
    sortable: true,
    formatter: HyperlinkForAutoMvReport
  },
  {
    prop: "Abril",
    label: "Abril",
    minWidth: 120,
    //fixed: true,
    sortable: true,
    formatter: HyperlinkForAutoMvReport
  },
  {
    prop: "Mayo",
    label: "Mayo",
    minWidth: 120,
    //fixed: true,
    sortable: true,
    formatter: HyperlinkForAutoMvReport
  },
  {
    prop: "Junio",
    label: "Junio",
    minWidth: 120,
    //fixed: true,
    sortable: true,
    formatter: HyperlinkForAutoMvReport
  },
  {
    prop: "Julio",
    label: "Julio",
    minWidth: 120,
    //fixed: true,
    sortable: true,
    formatter: HyperlinkForAutoMvReport
  },
  {
    prop: "Agosto",
    label: "Agosto",
    minWidth: 120,
    //fixed: true,
    sortable: true,
    formatter: HyperlinkForAutoMvReport
  },
  {
    prop: "Septiembre",
    label: "Septiembre",
    minWidth: 120,
    //fixed: true,
    sortable: true,
    formatter: HyperlinkForAutoMvReport
  },
  {
    prop: "Octubre",
    label: "Octubre",
    minWidth: 120,
    //fixed: true,
    sortable: true,
    formatter: HyperlinkForAutoMvReport
  },
  {
    prop: "Noviembre",
    label: "Noviembre",
    minWidth: 120,
    //fixed: true,
    sortable: true,
    formatter: HyperlinkForAutoMvReport
  },
  {
    prop: "Diciembre",
    label: "Diciembre",
    minWidth: 120,
    //fixed: true,
    sortable: true,
    formatter: HyperlinkForAutoMvReport
  }
];
